import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { referralPartnerApi } from '@/api/referralPartner';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

export default function PartnerForgotPassword() {
  const location = useLocation();
  const prefill = (location.state as { email?: string } | null)?.email ?? '';
  const [email, setEmail] = useState(prefill);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setMessage('');
    const trimmed = email.trim();
    if (!trimmed) {
      setError('Enter your registered email address.');
      return;
    }
    setLoading(true);
    try {
      await referralPartnerApi.forgotPassword(trimmed);
      setMessage(
        'If an account exists with this email, you will receive a password reset link shortly.',
      );
    } catch (err: unknown) {
      const msg = (err as { response?: { data?: { message?: string } } })?.response?.data?.message;
      setError(msg || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0a0f1a] px-4 py-10">
      <div
        className="pointer-events-none fixed inset-0 opacity-50"
        style={{
          background:
            'radial-gradient(ellipse 70% 50% at 50% 0%, rgba(34,211,238,0.25), transparent)',
        }}
      />
      <div className="relative w-full max-w-md rounded-3xl border border-white/10 bg-slate-900/80 p-5 sm:p-8 shadow-2xl backdrop-blur-xl">
        <p className="text-center text-xs font-semibold uppercase tracking-widest text-cyan-400">
          Partner Portal
        </p>
        <h1 className="mt-2 text-center text-2xl font-bold text-white">Forgot password</h1>
        <p className="mt-1 text-center text-sm text-slate-400">
          We&apos;ll email a reset link to your registered partner email.
        </p>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <Input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="border-white/10 bg-white/5 text-white placeholder:text-slate-500 h-11"
            autoComplete="email"
            required
          />
          {error ? <p className="text-sm text-red-400">{error}</p> : null}
          {message ? <p className="text-sm text-emerald-400">{message}</p> : null}
          <Button
            type="submit"
            disabled={loading}
            className="w-full h-11 bg-gradient-to-r from-cyan-500 to-violet-600 hover:from-cyan-400 hover:to-violet-500"
          >
            {loading ? 'Sending…' : 'Send reset link'}
          </Button>
        </form>
        <p className="mt-6 text-center text-sm text-slate-400">
          <Link to="/partner/login" className="font-medium text-cyan-400 hover:underline">
            Back to sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
